module.exports = __webpack_public_path__ + "static/media/folderIcon.7e729741.svg";